import {Trans} from '@lingui/macro';
import React from 'react';

import {EnumId, EnumParameter as RuleEnumParameter} from '../../../editors/commons/parameterModel';
import {SingleChoiceDropdown} from '../dropdowns/singleChoiceDropdown';
import {defaultDropdownWidth, GenericSingleParameterProps} from './genericParameter';

/*
 * Types.
 */

interface EnumItem {
  id: EnumId;
  name: string;
  tooltip?: string;
}

interface EnumParameterProps extends GenericSingleParameterProps<EnumItem> {
  enumParameter: RuleEnumParameter;
}

/*
 * Component.
 */

export const EnumParameter = ({enumParameter, ...rest}: EnumParameterProps) => {
  const items: EnumItem[] = enumParameter.enum.map((item, i) => {
    const name = enumParameter.enumTitles[i] ?? item;
    const description = enumParameter.enumDescriptions[i];

    // In most cases, the description is identitical to the name which is not very useful.
    const tooltip = description !== name ? description : undefined;

    return {
      id: item,
      name,
      tooltip,
    };
  });

  return (
    <SingleChoiceDropdown
      {...rest}
      items={items}
      getItemKey={(item) => String(item.id)}
      renderItemLabel={(item) => item.name}
      renderItemTooltip={(item) => item.tooltip}
      serializeItemForSearch={(item) => item.name}
      width={defaultDropdownWidth}
      placeholder={<Trans id="rule-editor-enum-param-placeholder">Select a value</Trans>}
    />
  );
};
